import { Background, Button, Container, ContentHeader } from '@/components/wm';
import { getStoreResource } from '@/utils';
import { NavigationService } from '@/utils/navigation';
import React from 'react';
import { ReadOnlySchedule } from './Content/ReadOnlySchedule';

export default function ShowAlarm({ modelData }) {
    const
        alarm = modelData,
        indicator = getStoreResource('indicators', alarm.indicator_id),
        indicatorName = indicator?.name || i18next.t('common.unknown'),
        siteName = getStoreResource('zones', alarm.site_id)?.name,
        users = alarm.user_ids?.map(userId => getStoreResource('users', userId)?.name).join(', ');

    const valuesHelper = value => {
        if (indicator?.unit === 'Wh' && alarm.max_value >= 1000) {
            return `${value / 1000} kWh`;
        }
        return `${value} ${indicator?.unit || ''}`;
    };

    const
        alarmMinValue = valuesHelper(alarm.min_value),
        alarmMaxValue = valuesHelper(alarm.max_value);

    const handleEdit = () => {
        NavigationService.navigateTo(`alarms/${alarm.id}/edit`);
    };

    const handleBack = () => {
        const backUrl = NavigationService.getBackHref();

        NavigationService.navigateTo(backUrl);
    };

    // Helper to render consistent data rows - Make this into a component
    const DataRow = ({ label, value }) => (
        <div className="tw-mb-4">
            <span className="tw-block tw-text-xs tw-font-semibold tw-text-muted-foreground tw-uppercase tw-tracking-wider">
                {label}
            </span>
            <span className="tw-block tw-text-sm tw-text-foreground">
                {value}
            </span>
        </div>
    );

    return (
        <Background>
            <Container>
                <ContentHeader icon="alarm" title={alarm.name}>
                    <Button className="tw-mr-2" onClick={handleEdit} size="sm">
                        {i18next.t('ui.buttons.edit')}
                    </Button>
                    <Button onClick={handleBack} size="sm">
                        {i18next.t('ui.buttons.back')}
                    </Button>
                </ContentHeader>

                <div className="tw-flex tw-flex-1 tw-w-full">

                    {/* Left Column (1/3 Width) */}
                    <div className="tw-w-[35%] tw-p-2 tw-border-solid tw-border-r tw-border-gray-100">
                        <DataRow label={i18next.t('glossary.indicator')} value={indicatorName}/>
                        <DataRow label={i18next.t('common.name')} value={alarm.name}/>
                        <DataRow label={i18next.t('glossary.site')} value={siteName}/>
                        <DataRow label={i18next.t('common.type')} value={i18next.t(`glossary.${alarm.type}`).capitalize()}/>
                        <DataRow label={i18next.t('indicators.min_value')} value={`${alarmMinValue}`}/>
                        <DataRow label={i18next.t('indicators.max_value')} value={`${alarmMaxValue}`}/>
                        <DataRow label={i18next.t('common.notifications')} value={users || i18next.t('common.none')}/>
                    </div>

                    {/* Right Column (2/3 Width - Remainder) */}
                    <div className="tw-w-[65%] tw-pl-4">
                        <ReadOnlySchedule
                            alarm={alarm}
                        />
                    </div>
                </div>
            </Container>
        </Background>
    );
}
